/**
 * Frontend twin of the backend `core/utils/vehicleType.ts`.
 *
 * The widgets and vehicle-card screens already speak the canonical lowercase
 * "car" | "mc". The outlier is the admin LEAD surface, whose DTO carries the legacy
 * "car" | "motorcycle" spelling (shipped Capacitor bundles read it, so it cannot change).
 * Anything comparing a lead's vehicleType to a literal is therefore a bug waiting to
 * happen - normalize first.
 */

export type VehicleType = "car" | "mc";

/**
 * Accepts any spelling the system produces ("mc", "MC", "motorcycle", "moped", "car",
 * "CAR", "bil") and returns the canonical value. Unsupported types ("truck", "tractor")
 * return undefined so callers fall back to their own inference.
 */
export const normalizeVehicleType = (raw: unknown): VehicleType | undefined => {
  if (typeof raw !== "string") return undefined;
  const value = raw.trim().toLowerCase();
  if (value === "mc" || value === "motorcycle" || value === "moped") return "mc";
  if (value === "car" || value === "bil") return "car";
  return undefined;
};

/** True when the value denotes a motorcycle in any spelling. */
export const isMotorcycle = (raw: unknown): boolean =>
  normalizeVehicleType(raw) === "mc";
